// extracted by css-extract-rspack-plugin
export default {"RowCountButton":"C_jSL","isHighlighted":"vi8YR","RowCountStaticLabel":"QCe4J"};